/**
 * DATA LAYER: MENCIONES OVERLAY
 * Se encarga de la comunicación HTTP con la API de Menciones.
 */

export const GetMencionesConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetMencionesConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ToggleMencionesVisibility = async (visible) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visible })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const CreateMencion = async (mencion) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mencion)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const UpdateMencion = async (id, mencion) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(mencion)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeleteMencion = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SelectMencion = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}menciones/select/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
